
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/money-fortune/Oldman",
      function () {
        return require("private-next-pages/money-fortune/Oldman.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/money-fortune/Oldman"])
      });
    }
  